// Preis-Formatierung nach italienischer Preisangaben-Verordnung (D.Lgs 206/2005):
// Betrag + Leerzeichen + € (DE/IT mit Komma), Einheitspreis als "40,00 €/kg".
export function formatEUR(value, lang = "de") {
  const n = Number(value || 0).toFixed(2);
  if (lang === "en") return `€${n}`;
  return `${n.replace(".", ",")} €`;
}

export function formatKgPrice(priceEur, weightG, lang = "de") {
  const perKg = ((Number(priceEur) || 0) / (Number(weightG) || 1)) * 1000;
  const n = perKg.toFixed(2);
  if (lang === "en") return `€${n}/kg`;
  return `${n.replace(".", ",")} €/kg`;
}
